import { Check, Copy, Rocket } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

import { Button } from "@/components/ui/button";
export const PublishSuccessModal = ({
  open,
  onClose,
  experienceName,
  campaignName,
  tenantName,
  inviteLink,
}) => {
  const copyInviteLink = async () => {
    try {
      await navigator.clipboard.writeText(inviteLink);
    } catch (error) {
      console.error("Failed to copy invite link:", error);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        className="
          w-[calc(100vw-32px)]
          max-w-[640px]
          rounded-lg
          border
         border-brand-11
          bg-brand-19
          px-6
          py-10
          text-center
          text-neutral-100
          shadow-2xl
          sm:px-10
          sm:py-12
        "
      >
        <DialogHeader className="text-center">
          <div className="mx-auto mb-5 flex h-20 w-20 items-center justify-center rounded-full bg-[#123D31]">
            <div className="flex h-14 w-14 items-center justify-center rounded-full bg-[#05C92F]">
              <Check className="h-9 w-9 text-neutral-100" />
            </div>
          </div>

          <DialogTitle className="text-center text-2xl font-bold text-[#67D8FF]">
            Experience is now live
          </DialogTitle>

          <DialogDescription className="mx-auto mt-4 max-w-md text-center text-sm font-semibold leading-relaxed text-neutral-100">
            Your experience has been successfully published and is now available
            to users in the selected campaign.
          </DialogDescription>
        </DialogHeader>

        <div className="mx-auto mt-8 w-full max-w-md space-y-3 text-left">
          <PublishInfoRow label="Experience:" value={experienceName} />
          <PublishInfoRow label="Campaign:" value={campaignName} />
          <PublishInfoRow label="Tenant:" value={tenantName} />

          <div className="flex items-center rounded-md bg-[#30415D] px-4 py-3 text-sm">
            <span className="w-[110px] shrink-0 font-bold text-neutral-100">
              Invite Link :
            </span>

            <span className="flex-1 break-all font-bold text-[#00D3F2]">
              {inviteLink}
            </span>

            <button
              type="button"
              onClick={copyInviteLink}
              className="ml-3 text-neutral-100 hover:text-[#00D3F2]"
            >
              <Copy className="h-5 w-5" />
            </button>
          </div>
        </div>

        <div className="mt-10 flex justify-center">
          <Button
            type="button"
            variant="outline"
            onClick={onClose}
            className="h-10 min-w-[110px] border-[#607A9B] bg-[#223957] px-8 font-bold text-neutral-100 hover:bg-[#2B466B] hover:text-neutral-100"
          >
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

const PublishInfoRow = ({ label, value }) => {
  return (
    <div className="flex items-center rounded-md bg-[#30415D] px-4 py-3 text-sm">
      <span className="w-[110px] shrink-0 font-bold text-neutral-100">{label}</span>
      <span className="font-bold text-neutral-100">{value}</span>
    </div>
  );
};
